const destinationMapper = (appliedFilter) => {
  const isDomestic = appliedFilter.criterionArgumentValue;
  return {
    booleanFilters: [
      {
        column: 'IsInternational',
        value: !isDomestic,
      },
    ],
  };
};

export default destinationMapper;
